// extracted by mini-css-extract-plugin
export default {"container":"Movies_container__sNK5N","movies":"Movies_movies__tPRCM","movies__title":"Movies_movies__title__Z+XHt","movie__container":"Movies_movie__container__CzREo"};